import { Box } from "@mui/material";
import { COLORS } from "../../../dashboard/epis-dashboard/configs/config";
export default function StackedBar({ partes, total }) {
    const fmt = (n) => (n ?? 0).toLocaleString("pt-BR");
    return (
        <Box sx={{ display: "flex", height: 12, borderRadius: 6, overflow: "hidden", bgcolor: COLORS.kpiBg }}>
            {partes.map((p) => (
                <Box
                    key={p.label}
                    title={`${p.label}: ${fmt(p.valor)}`}
                    sx={{ width: `${total ? (p.valor / total) * 100 : 0}%`, bgcolor: p.cor, transition: "width .4s" }}
                />
            ))}
        </Box>
    );
}